<template>
    <div class="opui-container opui-max-900" v-if="err && errorMessage">
        <div class="opui-alert opui-alert-dismissible opui-alert-danger">
            <button type="button" class="opui-close" data-bs-dismiss="alert"></button>
            <strong>Oh snap!</strong>
            <p>{{ errorMessage }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        err: { type: Object, required: true },
    },
    computed: {
        errorMessage() {
            return this.err.message || null
        }
    }
}
</script>
